import React from 'react'
import { useLocation } from 'react-router-dom'
import PressArticle from '../components/press/PressArticle'

const ViewPress = () => {
  let location = useLocation()

  return (
    <>
    {
    location.state.data ? 
      <PressArticle {...location.state.data} /> :
      <p>___</p>
    }
    </>
  )
}

export default ViewPress